import { Component, Input, OnInit } from '@angular/core';
import { NgForm }                   from '@angular/forms';
import { TranslateService }         from '@ngx-translate/core';

import { InitialUserSetupModel } from './typings/user.initial-setup';
import { LoginService }          from '../login/login.service';
import { MessagesService }       from '../../app-lite/messages/messages.service';
import { UserService }           from './user.service';

@Component({
  selector   : 'wor-verify-user',
  template: require('./user.verify.component.html')
})
export class VerifyUserComponent implements OnInit {
  @Input() countryCode   : string;
  @Input() customerId    : string;
  @Input() subscriptionId: string;
  @Input() username      : string;

  user: InitialUserSetupModel = {};

  constructor (
    private loginService    : LoginService,
    private messagesService : MessagesService,
    private translateService: TranslateService,
    private userService     : UserService
  ) {}

  ngOnInit () : void {
    this.user = {
      confirm_password: '',
      country_code    : this.countryCode,
      password        : '',
      unlock_code     : '',
      username        : this.username
    };

    if ( this.customerId && this.subscriptionId ) {
      this.verifySubscription();
    }
  }

  save ( form : NgForm ) : void {
    this.userService.saveInitialSetup(this.user)
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.USER_CREATED_CHARGIFY'), 'success');

      this.loginService.login(this.user);
    })
    .catch(error => {
      this.messagesService.error(error);
    });
  }

  verifySubscription () : void {
    this.userService.verifySubscription(this.customerId, this.subscriptionId)
    .catch(error => {
      this.messagesService.error(error);
    });
  }
}
